import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { bankIDLogin, bankIDLoginReset } from './actions';

export function useBankIDLogin() {
  const {
    isSuccessful,
    loading,
    error,
    orderRef,
    isInitSuccessful,
  } = useSelector(state => state.bankIDLogin);

  const dispatch = useDispatch();

  useEffect(() => () => dispatch(bankIDLoginReset()), [dispatch]);

  return {
    isSuccessful,
    loading,
    error,
    orderRef,
    isInitSuccessful,
    onLoginWithBankID: (personalNumber) => dispatch(bankIDLogin(personalNumber)),
  };
}
